// extracted by mini-css-extract-plugin
export default {"modal":"ModalConfirmAction_modal__wDKOS","btn-main":"ModalConfirmAction_btn-main__b7xJP","btn-cancel":"ModalConfirmAction_btn-cancel__8g4vl"};